import React, { PureComponent } from 'react';
import { withRouter, Link } from "react-router-dom";

import { Col, Card, CardBody } from 'reactstrap';
import { Tooltip } from '@material-ui/core';
import LinearLoading from '../../../../shared/components/LinearLoading';
import Button from '@material-ui/core/Button';
import LoadMoreIcon from 'mdi-react/RefreshIcon';
import LoadingIcon from 'mdi-react/DotsHorizontalIcon';
import SliderItems from './SliderItems';
import Panel from '../../../../shared/components/Panel';


import { _buildingIDs, _axiosCall } from '../../../../shared/helpers/apicalls';
import { 
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_nameToUrl,
	_shouldShow,
	_getBuildingURL,
	_replaceAbbreviations,
	_formatBed,
	_calPercentage,
	_checkFieldForValue,
	_isCCC,
	propertyFL,
} from "../../../../shared/helpers/utils";

const apiURL = process.env.API_ROOT + '/query/';



const ContentSlider = (props) => {
  const {  title, subhead, label,  items, CallOut, setSubmit , setIsBuilding } = props;
  
  return(
		  <Panel 
		  	md={12}
		  	lg={12}
		  	xl={12} 
		  	title={title}
		  	subhead={subhead}
		  	label={label}
			
		  >
		  <div className="mc-content-cards">
		  	<div className="catalog">
		    	<SliderItems {...props} />
		  	</div>
		  	{/* <div className="marketing">
		   	{CallOut ? CallOut : null}
		  	</div> */}
		  </div>
		  </Panel>
	  )
	  
  
  
}

export default withRouter(ContentSlider);
